<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2 text-center">
      <h2 class="mb-2 text-center">Verify Code</h2>
      You should have received a 6-digit code.  Enter it below along with your new password.
    </div>
    <v-form ref="form" @submit.prevent="verifyClick">
      <v-otp-input 
        length="6" class="mb-4"
        type="number"
        v-model="code"
        :rules="[required, valid_code]"
        tabindex="1"
      />

      <v-text-field
        v-model="password"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Choose New Password"
        :rules="[required, valid_password]"
        validate-on-blur tabindex="2"
        placeholder=" " persistent-placeholder
        autocomplete="new-password" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />
      <v-text-field
        v-model="confirmation"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Confirm Password"
        :rules="[required, matches_password]"
        validate-on-blur tabindex=3
        placeholder=" " persistent-placeholder
        autocomplete="new-confirm" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />
      <div class="ml-3 mt-n1 mb-5">
        Didn't receive your code?
        <a style="text-decoration: underline;" @click="resendClick">Request again.</a>
      </div>
      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Update Password</v-btn>
      </div>
    </v-form>

    <div class="ml-3 mt-3 text-center">
      <a style="text-decoration: underline;" @click="loginClick">Back to Login</a>
    </div>

    <ErrorOverlay
      title="Password Reset Error" 
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { required, valid_code, valid_password, matches } from '@/lib/validations'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'RecoverVerifyView',

  mixins: [ ErrorOverlayMixin ],

  props: ['id'],

  data() {
    return {
      code: '',
      password: '',
      confirmation: '',
      pw_visible: false,

      // validation rules
      required,
      valid_code,
      valid_password,
    }
  },

  computed: {
    ...mapGetters('auth', ['unverifiedUser']),

    // validation rules requiring access to data
    matches_password() { return matches(this.password, 'Password') }
  },

  methods: {
    ...mapActions('auth', ['resetPassword']),
    ...mapMutations('auth', { setAcceptanceKeys: 'SET_ACCEPTANCE_KEYS'}),

    loginClick() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ name: 'login' })        
      }
    },

    resendClick() {
      if (this.unverifiedUser) {
        this.$router.replace({ name: 'recover/methods' })
      } else if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ name: 'login' })        
      }
    },

    async verifyClick() {
      if (this.$refs.form.validate()) {
        
        let payload = { 
          password_recovery_code: this.code,
          password: this.password,
        }

        if(this.id) {
          payload.user_id = this.id
        } else {
          payload.id = this.unverifiedUser
        }

        this.loading = true
        const result = await this.resetPassword(payload)
        this.loading = false

        if (result.ok) {
          this.$router.replace({ name: 'referrals'})
        } else if (result.status == 403) {
          this.setAcceptanceKeys(result)
          this.$router.replace({ name: 'login/accept' })
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>
